import { render, staticRenderFns } from "./ACQ5.vue?vue&type=template&id=5d9bfa4b&scoped=true&lang=pug&"
import script from "./ACQ5.vue?vue&type=script&lang=js&"
export * from "./ACQ5.vue?vue&type=script&lang=js&"
import style0 from "./ACQ5.vue?vue&type=style&index=0&id=5d9bfa4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9bfa4b",
  null
  
)

export default component.exports